export default __webpack_public_path__ + "static/discussions_debates-9868d447e0cb83ca10123cd57b6feaab.png";